/**
 * Debug utilities for conditional logging
 * Only enables debug logging for specific authorized users in all environments
 */

// Authorized debug users
const DEBUG_AUTHORIZED_EMAILS = [
  'chetan@radon-media.com',
  'chetan.parmar1@gmail.com'
];

/**
 * Check if the current user is authorized for debug logging
 */
export function isDebugAuthorized(userEmail?: string | null): boolean {
  if (!userEmail) return false;
  return DEBUG_AUTHORIZED_EMAILS.includes(userEmail.toLowerCase());
}

/**
 * Conditional console.log that only logs for authorized users (works in both dev and production)
 */
export function debugLog(userEmail: string | null | undefined, message: string, ...args: any[]): void {
  if (isDebugAuthorized(userEmail)) {
    console.log(`[DEBUG] ${message}`, ...args);
  }
}

/**
 * Conditional console.error that only logs for authorized users (works in both dev and production)
 */
export function debugError(userEmail: string | null | undefined, message: string, ...args: any[]): void {
  if (isDebugAuthorized(userEmail)) {
    console.error(`[DEBUG] ${message}`, ...args);
  }
}

/**
 * Conditional console.warn that only logs for authorized users (works in both dev and production)
 */
export function debugWarn(userEmail: string | null | undefined, message: string, ...args: any[]): void {
  if (isDebugAuthorized(userEmail)) {
    console.warn(`[DEBUG] ${message}`, ...args);
  }
}

/**
 * Check if debug mode is enabled (authorized user in any environment)
 */
export function isDebugMode(userEmail: string | null | undefined): boolean {
  return isDebugAuthorized(userEmail);
}